import { register } from '@shopify/theme-sections'
import '../../styles/sections/template-contact.scss'
import '../modules/form-validation'
import { ContactForm } from '../sections/index-contact'

export default register(`template-contact`, {
  onLoad() {
    const clickForm = document.querySelector(`.form-body`)
    const $target = document.querySelector(`#form-body`)
    const $successful = document.querySelector(`.posted-successfully`)

    ContactForm()

    if (clickForm) {
      clickForm.addEventListener(`click`, element => {
        element.preventDefault()

        $target.classList.remove(`hide`)
        $successful.classList.add(`hide`)
      })
    }
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {},
})
